import { render, staticRenderFns } from "./base-image.vue?vue&type=template&id=2c2f2989&"
import script from "./base-image.vue?vue&type=script&lang=js&"
export * from "./base-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports